<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Servers" button-url="pmtaServerCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                />
                            </div>
                            <input v-model="serverSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by PMTA name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="serverList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Name</th>
                                                <th>IP</th>
                                                <th>Owner</th>
                                                <th>Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(server, index) in serverList" :key="index">
                                                <td class="align-middle">{{server.id}}</td>
                                                <td class="align-middle">{{server.name}}</td>
                                                <td class="align-middle">{{server.serverIp}}</td>
                                                <td class="align-middle">{{server.user.username}}</td>
                                                <td class="align-middle">
                                                    <router-link
                                                            :to="{ name: 'pmtaServerEdit', params: { id: server.id }}"
                                                            class="btn btn-sm btn-info m-r-10">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </router-link>
                                                    <router-link
                                                            :to="{ name: 'pmtaRelayFilter1', params: { serverId: server.id }}"
                                                            class="btn btn-sm btn-warning m-r-10">
                                                        <i class="ti-server"></i> Relays
                                                    </router-link>
                                                    <router-link
                                                            :to="{ name: 'pmtaServerBalancers', params: { id: server.id }}"
                                                            class="btn btn-sm btn-primary m-r-10">
                                                        <i class="fa fa-hockey-puck"></i> Balancers
                                                    </router-link>
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                            @click="deleteServer(server.id)">
                                                        <i class="fa fa-minus-circle"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <paginate v-if="pageCount > 1"
                                              v-model="page"
                                              :page-count="pageCount"
                                              :page-range="3"
                                              :margin-pages="2"
                                              :click-handler="getItems"
                                              :prev-text="'Prev'"
                                              :next-text="'Next'"
                                              :container-class="'pagination justify-content-center'"
                                              :page-class="'page-item'"
                                              :page-link-class="'page-link'"
                                              :prev-class="'page-item'"
                                              :prev-link-class="'page-link'"
                                              :next-class="'page-item'"
                                              :next-link-class="'page-link'">
                                    </paginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import PmtaServerService from '../services/PmtaServerService';
    import UserService from '../services/UserService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';

    export default {
        name: 'PmtaServers',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                serverList: [],
                serverSearch: null,
                userSearch: null,
                userList: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                PmtaServerService.getServers(pageNum, this.perPage, this.serverSearch, this.userSearch).then(response => {
                    this.serverList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            deleteServer(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PmtaServerService.deleteServer(id).then((response) => {
                            if (response.status === 204) {
                                let serverIndex = this.serverList.findIndex(obj => obj.id === id);
                                this.serverList.splice(serverIndex, 1);
                                this.totalItems--;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                'Error: ' + error.response.data.error[0]
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Server has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>